var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCornerLeftDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 1.25C20.4142 1.25 20.75 1.58579 20.75 2C20.75 2.41421 20.4142 2.75 20 2.75H12.7143C11.4717 2.75 10.4643 3.75736 10.4643 5V15.6944H15.4286C15.7339 15.6944 16.0087 15.8795 16.1235 16.1623C16.2383 16.4452 16.1703 16.7694 15.9514 16.9822L10.2371 22.5377C9.94603 22.8208 9.48259 22.8208 9.1915 22.5377L3.47722 16.9822C3.25834 16.7694 3.19028 16.4452 3.30511 16.1623C3.41994 15.8795 3.69475 15.6944 4.00002 15.6944H8.96431V5C8.96431 2.92893 10.6432 1.25 12.7143 1.25H20Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerLeftDown);
export default __webpack_public_path__ + "static/media/corner-left-down.e7fa64c96f54eb8c0bf5d05237d8486d.svg";
export { ForwardRef as ReactComponent };